export function LeadTimeMutationError({
  errors,
}: {
  errors: Array<Error | null>;
}) {
  const error = errors.find((value) => value !== null);
  if (!error) return null;
  return (
    <p role="alert" className="text-xs text-destructive">
      {error.message}
    </p>
  );
}
